import { render, staticRenderFns } from "./urgency_edit.vue?vue&type=template&id=77994d2a&"
import script from "./urgency_edit.vue?vue&type=script&lang=js&"
export * from "./urgency_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports